import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from '@material-ui/core';
import './dialog.scss';
export var DialogDefault = function (props) {
    var t = useTranslation().t;
    var open = props.open, handleClose = props.handleClose, title = props.title, children = props.children, onSave = props.onSave, isDisable = props.isDisable, actionName = props.actionName;
    return (React.createElement(Dialog, { open: open, fullWidth: true, maxWidth: 'xs', className: "dialog-note", onClose: handleClose, "aria-labelledby": "form-dialog-title", BackdropProps: {
            classes: {
                root: "dialog-default-backdrop"
            }
        } },
        React.createElement(DialogTitle, { id: "form-dialog-title" }, title),
        React.createElement(DialogContent, null, children),
        React.createElement(DialogActions, { className: "dialog-actions-note" },
            React.createElement(Button, { onClick: handleClose, color: "primary" }, t("common.cancel")),
            React.createElement(Button, { onClick: onSave, disabled: isDisable, color: "primary" }, actionName))));
};
